<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['request_payout'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <BalanceDetails />
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <!-- Table busy spinner -->
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner v-if="data_status == 'Fetching data...'" class="align-middle" type="grow"></b-spinner>
                    <span v-else class="mdi mdi-cancel fs-1"></span>
                    <div class="fw-bold fs-5">{{ data_status }}</div>
                  </div>
                </template>

                <!-- Row index -->
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <!-- Toggle button to show row details -->
                <template #cell(actions)="row">
                  <i v-if="!row.detailsShowing" class="mdi mdi-chevron-down fs-3 px-1"
                    @click.prevent="toggleRowDetails(row)" style="cursor: pointer;"></i>
                  <i v-else class="mdi mdi-chevron-up fs-3 px-1" @click.prevent="toggleRowDetails(row)"
                    style="cursor: pointer;"></i>

                  <!-- {{ row.detailsShowing ? 'Hide' : 'Show' }} Details -->

                </template>

                <!-- Row details template -->
                <template #row-details="row">
                  <div class="container">
                    <div class="container shadow-lg py-2">
                      <div class="row">
                        <div class="col-2 fw-bold">Description: </div>
                        <div class="col">{{ row.item.description || 'None' }}</div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- Account name with account number -->
                <template #cell(account_name)="data">
                  <div>{{ data.item.account_name }}</div>
                  <small class="text-primary fw-bold">{{ data.item.account_number }}</small>
                </template>

                <!-- Added by (user name and email) -->
                <template #cell(addedby)="data">
                  <div>
                    <div>{{ data.item.addedby.name }}</div>
                    <small class="text-primary fw-bold">{{ data.item.email }}</small>
                  </div>

                </template>

                <!-- Status badge -->
                <template #cell(status)="data">
                  <b-badge v-if="data.item.status == '2'" pill class="bg-warning p-1">Pending</b-badge>
                  <b-badge v-else-if="data.item.status == '3'" pill class="bg-info p-1">Paid</b-badge>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to View {{title}}</span>
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { payoutrequestComputed, payoutrequestMethods } from "@/state/helpers";
import BalanceDetails from "./balanceDetails";

export default {
  page: {
    title: "Payout History",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    BalanceDetails
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Payout History",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Payout History", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "addedby", label: "Requested by", visible: true },
        { key: "bank_name", label: "Bank", visible: true },
        { key: "account_name", label: "Bank Account", visible: true },
        { key: "amount", label: "Request Amount", visible: true },
        { key: "status", label: "Status", visible: true },
        { key: "created_at", label: "Added on", visible: true },
        { key: "actions", label: "", visible: true },
      ],
      date_to: new Date().toLocaleDateString("fr-CA"),
      date_from: new Date().toLocaleDateString("fr-CA"),
      data_status: "Fetching data...",
    };
  },
  computed: {
    ...payoutrequestComputed,
    List() {
      return this.payoutrequests.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.payoutrequests.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.payoutrequests.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },

  async mounted() {
    await this.fetchPayoutRequests()
    this.data_status = "No data found";
    this.TotalRows = this.payoutrequests.length;
    this.isBusy = false;
  },

  methods: {
    ...payoutrequestMethods,

    toggleRowDetails(row) {
      row.toggleDetails();
    },

    restore(id, name) {
      this.id = id
      this.name = name
      this.$bvModal.show('restore-applicant')
    },

    async restoreApplicant() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "restore_application";
      const response = await axios.post(url, formData);
      if (response.status == 200) {
        this.fetchApplicants();
        this.$bvModal.hide('restore-applicant')
        this.$toast.success(
          `Application for ${response.data.applicant}, Restored!`
        );
      }
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(
      id,
      name,
      gender,
      telephone,
      nationality,
      address,
      dateofbirth,
      nin,
      date_of_joining,
      sacco_member_id,
      savingpackage,
      nokname,
      nokcontact,
      email,
      username
    ) {
      this.id = id;
      this.name = name;
      this.gender = gender;
      this.telephone = telephone;
      this.nationality = nationality;
      this.address = address;
      this.dateofbirth = dateofbirth;
      this.nin = nin;
      this.date_of_joining = date_of_joining;
      this.sacco_member_id = sacco_member_id;
      this.savingpackage = savingpackage.id;
      this.nokname = nokname;
      this.nokcontact = nokcontact;
      this.email = email;
      this.username = username;
      this.$bvModal.show("edit-member");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("reject-applicant");
    },

    async editMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("gender", this.gender);
      formData.append("telephone", this.telephone);
      formData.append("nationality", this.nationality);
      formData.append("address", this.address);
      formData.append("dateofbirth", this.dateofbirth);
      formData.append("nin", this.nin);
      formData.append("date_of_joining", this.date_of_joining);
      formData.append("sacco_member_id", this.sacco_member_id);
      formData.append("nokname", this.nokname);
      formData.append("nokcontact", this.nokcontact);
      formData.append("savingpackage", this.savingpackage);
      formData.append("email", this.email);
      formData.append("username", this.username);
      let url = "/updatemember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMembers();
          this.$bvModal.hide("edit-member");
        }
      });
    },
    async removeMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/reject_application";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchApplicants();
          this.$bvModal.hide("reject-applicant");
          this.$toast.error(
            `Application for ${response.data.applicant}, Deleted!`
          );
        }
      });
    },
    FilterData() {
      this.filterMembers({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>
